export const mediaQueries = {
  regular: '(min-width: 768px)',
  wide: '(min-width: 1280px)',
} as const;
